import { Modal, ScrollArea } from "@mantine/core";
import { ColumnDefinition, TestListItem } from "@components/result_list/types/testListTypes";
import { useEffect, useState } from "react";

import TestList from "@components/result_list/TestList";
import { getTestList } from "@utils/api-communication/RestApiCli";
import { useTranslation } from "react-i18next";

interface TestSelectorModalProps {
  uuid: string;
  patientId: string;
  opened: boolean;
  onClose: () => void;
}

export default function TestSelectorModal({
  uuid,
  patientId,
  opened,
  onClose,
}: TestSelectorModalProps) {
  const { t } = useTranslation();
  const [tests, setTests] = useState<TestListItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!uuid || !opened) return;

    setLoading(true);
    getTestList({ patientId, limit: 100 }, (response) => {
      const filteredTests = response.data.data
        .filter((test) => test.category === "VFA" || !test.category)
        .map(
          (test) =>
            ({
              uuid: test.uuid,
              patientName: test.patientName || "",
              startDate: test.startDate,
              category: test.category,
              testType: test.testType,
              eye: test.eye,
            }) as TestListItem,
        );

      setTests(filteredTests);
      setLoading(false);
    });
  }, [uuid, opened, patientId]);

  const columns: ColumnDefinition[] = [
    {
      dataField: "startDate",
      text: t("ResultList.date") || "Date",
      formatter: (cell: string | Date) => {
        const dateStr = typeof cell === "string" ? cell : cell.toISOString();
        return dateStr.split("T")[0];
      },
    },
    {
      dataField: "eye",
      text: t("TestController.eye") || "Eye",
      formatter: (cell: string) => {
        return cell === "rightEye" ? t("TestController.rightEye") : t("TestController.leftEye");
      },
    },
    {
      dataField: "testType",
      text: t("TestType.testType") || "Type",
    },
  ];

  const handleItemClick = (item: TestListItem) => {
    window.location.href = `/test-result?uuid=${uuid}&second=${item.uuid}`;
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="50%"
      title={t("TestController.selectTestToCompare")}
    >
      <ScrollArea h={350}>
        <TestList
          data={tests}
          loading={loading}
          columns={columns}
          onItemClick={handleItemClick}
          viewMode="table"
          showDateGroups={false}
          showActionButtons={false}
        />
      </ScrollArea>
    </Modal>
  );
}
